import React from "react";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { KEY_LABELS } from "../constants/visitDataAccordian";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import { humanisetime } from "../utils/formatters";
import moment from "moment";
import {
  GOOD_SYSTEM_BUILD_VERSION,
  SCHOOL_DATA_CONSTANTS,
  NEW_SD_CARD_VERSION_AY,
  SD_CARD_PROFILE_NAME,
} from "../constants/schoolData";
import InfoIcon from "../assets/info_icon.svg";
import {
  getExpectedSystemBuildVersion,
  getSDCardErrorMessage,
  checkSDCardErrorState,
} from "../utils/common";
const StatusTab = ({
  data,
  className = "",
  showHeader = false,
  handleDeviceClick = () => null,
  overAllStatus,
}) => {
  const cardHeader = () => {
    return (
      <div className="card-header-container row">
        <div className="card-header-section col-sm-4 col-md-3 col-lg-3 username-and-role-info">
          <div className="row">
            <div>
              <span className="font-weight-bold mr-2">Name:</span>
              <span>{data.name || ""}</span>
            </div>
          </div>
          <div className="row">
            <div>
              <span className="font-weight-bold mr-2">Role:</span>
              <span>{data.roleName || ""}</span>
            </div>
          </div>
        </div>
        <div className="card-header-section col-sm-4 col-md-2 col-lg-2">
          <span className="font-weight-bold mr-2">Login Id:</span>
          <span>{data.teacherMobile}</span>
        </div>
        <div className="card-header-section col-sm-4 col-md-3 col-lg-3">
          <span className="font-weight-bold mr-2">{KEY_LABELS.timestamp}:</span>
          <span>
            {humanisetime(moment.utc(data.lastTimestamp).local())} (
            {overAllStatus})
          </span>
        </div>
        <div className="card-header-section col-sm-4 col-md-3">
          <h6>
            {data.actions && data.actions.length > 0 ? (
              <Badge
                variant="info"
                disabled
                onClick={(event) => handleDeviceClick(data, event, "action")}
                style={{ cursor: "pointer" }}
              >
                {data.actions[0]}{" "}
                {data.actions.length > 1
                  ? ` (+${data.actions.length - 1})`
                  : ""}
              </Badge>
            ) : (
              ""
            )}
          </h6>
        </div>
        <div className="link-container">
          <Link
            to={`/schoolData/${data?.schoolId}`}
            className="redirect-to-school-link"
          >
            <div className="d-flex">
              <i className="fa fa-home"></i>
              School
            </div>
          </Link>
        </div>
      </div>
    );
  };

  const renderIcon = (dataState) => {
    if (dataState === 0) {
      return (
        <i className="fa fa-check-circle text-success" aria-hidden="true"></i>
      );
    } else if (dataState === 2) {
      return (
        <i className="fa fa-times-circle text-danger" aria-hidden="true"></i>
      );
    } else {
      return (
        <i
          className="fa fa-exclamation-circle text-warning"
          aria-hidden="true"
        ></i>
      );
    }
  };

  const humanizeBytes = (size) => {
    return bytesToGB(size) + " GB";
  };

  function bytesToGB(bytes) {
    const gigabytes = bytes / (1024 * 1024 * 1024);
    return Math.ceil(gigabytes * 10) / 10;
  }

  const getSdCardProfileName = (sdCardVersionNumber) => {
    if (!sdCardVersionNumber) return '';
    const requiredKey = sdCardVersionNumber?.split('-')[0];
   return  SD_CARD_PROFILE_NAME[requiredKey] || '';
  }
    
  const getSdCardInfoComponent = (data) => {
    if (data?.academicYear >= NEW_SD_CARD_VERSION_AY) {
      return (
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.sdCardErrorMessage}:
          </div>
          <div className="col-5">
            {renderIcon(
              checkSDCardErrorState(data) ? 2 : 0
            )}
          </div>
        </div>
      )
    }

    return (
      <div className="row mb-2">
        <div className="col-7 label font-weight-bold">
          {KEY_LABELS.sdCardErrorMessage}:
        </div>
        <div className="col-5">
          {renderIcon(
            getSDCardErrorMessage(data?.sdCardErrorMessage) ? 2 : 0
          )}
          {getSDCardErrorMessage(data?.sdCardErrorMessage) && (
            <OverlayTrigger
              key="error-tooltip"
              placement="top"
              overlay={
                <Tooltip id="tooltip-top" style={{ fontSize: "12px" }}>
                  {data?.sdCardErrorMessage}
                </Tooltip>
              }
            >
              <button className="error-info-btn">
                <img src={InfoIcon} alt="error-info-icon" />
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="row card-body-container">
      <div className="card-body-section col-sm-12 col-md-6 col-lg-6">
        <div className="row mb-2">
          <div className="col-7 font-weight-bold">{KEY_LABELS.appVersion}:</div>
          <div className="col-5 d-flex">
            {renderIcon(data.appVersionStatus)}
            {data.appVersion}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.triggeredFrom}:
          </div>
          <div className="col-5 d-flex">
            {renderIcon(data.oneClickStatus)}
            {data.triggeredFrom}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.canManageExternalStorage}:
          </div>
          <div className="col-5 d-flex">
            {renderIcon(2 - parseInt(data.canManageExternalStorage) * 2)}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">Nas Connectivity:</div>
          <div className="col-5 d-flex">{renderIcon(data.nasStatus)}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">Resource Download:</div>
          <div className="col-5 d-flex">{renderIcon(data.resourceStatus)}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            Tab Performance SW:
          </div>
          <div className="col-5 d-flex">{renderIcon(data.mdmstate)}</div>
        </div>
        <hr></hr>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.totalResources}:
          </div>
          <div className="col-5">{data.totalResources}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.redResources}:
          </div>
          <div className="col-5">{data.redResources}</div>
        </div>

        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.teacherTotalResources}:
          </div>
          <div className="col-5">{data.teacherTotalResources}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.teacherRedResources}:
          </div>
          <div className="col-5">{data.teacherRedResources}</div>
        </div>
        <hr />
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.contentPersistenceRunAt}:
          </div>
          <div className="col-5">
            {humanisetime(data.contentPersistenceRunAt)}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.oneClickRunAt}:
          </div>
          <div className="col-5">{humanisetime(data.oneClickRunAt)}</div>
        </div>
        <hr />

        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.tabModel}:
          </div>
          <div className="col-5">{data.tabModel}</div>
        </div>

        {!!(window.innerWidth < 768) && <hr></hr>}
      </div>
      <div className="card-body-section col-sm-12 col-md-6 col-lg-6">
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.totalExternalStorage}:
          </div>
          <div className="col-5">
            {humanizeBytes(data.totalExternalStorage)}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.availableExternalStorage}:
          </div>
          <div className="col-5">
            {humanizeBytes(data.availableExternalStorage)}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.sdCardSerialNumber}:
          </div>
          <div className="col-5">{data.sdCardSerialNumber}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.sdCardVersion}:
          </div>
          <div className="col-5">{data.sdCardVersion}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.sdCardProfileName}:
          </div>
          <div className="col-5">{getSdCardProfileName(data.sdCardVersion)}</div>
        </div>
        {/* <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.sdCardUpdatedDate}:
          </div>
          <div className="col-5">{data?.sdCardUpdatedDate}</div>
        </div> */}
        {data?.type === SCHOOL_DATA_CONSTANTS.device.tab && getSdCardInfoComponent(data)}
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.preparedDate}:
          </div>
          <div className="col-5">{data.preparedDate}</div>
        </div>
        <hr />

        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.nasIpLastConnected}:
          </div>
          <div className="col-5">{data.nasIpLastConnected}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.wifiName}:
          </div>
          <div className="col-5">
            {data.wifiName}
          </div>
        </div>
        <hr />
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.mdmDeviceId}:
          </div>
          <div className="col-5">{data.mdmDeviceId}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.enrolledTime}:
          </div>
          <div className="col-5">
            {data?.enrolledTime
              ? moment(data?.enrolledTime).format("DD-MM-YYYY HH:MM A")
              : ""}
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.isLocked}:
          </div>
          <div className="col-5">{data?.locked ? "true" : "false"}</div>
        </div>
        <div className="row mb-2">
          <div className="col-7 label  font-weight-bold">
            {KEY_LABELS.teacherId}:
          </div>
          <div className="col-5">{data.teacherId}</div>
        </div>
        <div className="row mb-2">
          <div className="col-4 label font-weight-bold">
            {KEY_LABELS.deviceId}:
          </div>
          <div className="col-8">{data.deviceId}</div>
        </div>  
        {data?.type === SCHOOL_DATA_CONSTANTS.device.tab && (
          <div className="row mb-2">
            <div className="col-7 label font-weight-bold">Firmware Status:</div>
            {data?.systemBuildVersion && data?.systemBuildVersion.length > 4 ? (
              <div className="col-5 d-flex">
                {renderIcon(data.systemBuildVersionStatus)}
                {GOOD_SYSTEM_BUILD_VERSION.includes(data.systemBuildVersion) ? (
                  <OverlayTrigger
                    key="error-tooltip"
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-top" style={{ fontSize: "12px" }}>
                        Current Version: {data.systemBuildVersion}
                      </Tooltip>
                    }
                  >
                    <button className="error-info-btn">
                      <img src={InfoIcon} alt="error-info-icon" />
                    </button>
                  </OverlayTrigger>
                ) : (
                  <OverlayTrigger
                    key="error-tooltip"
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-top" style={{ fontSize: "11px" }}>
                        Current Version: {data?.systemBuildVersion} <br />
                        Expected Version:
                        <div
                          dangerouslySetInnerHTML={{
                            __html: getExpectedSystemBuildVersion(
                              data?.systemBuildVersion
                            ),
                          }}
                        />
                      </Tooltip>
                    }
                  >
                    <button className="error-info-btn">
                      <img src={InfoIcon} alt="error-info-icon" />
                    </button>
                  </OverlayTrigger>
                )}
              </div>
            ) : (
              <div className="col-5 d-flex">
                <OverlayTrigger
                  key="error-tooltip"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top" style={{ fontSize: "11px" }}>
                      We currently lack the necessary details or data regarding
                      the firmware
                    </Tooltip>
                  }
                >
                  <i className="fa fa-info-circle" aria-hidden="true"></i>
                </OverlayTrigger>
              </div>
            )}
          </div>
        )}
        <div className="row mb-2">
          <div className="col-7 label font-weight-bold">
            {KEY_LABELS.developerOptionEnabled}:
          </div>
          <div className="col-5 d-flex">
            {renderIcon(1 - parseInt(data.developerOptionEnabled) * 1)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusTab;
